import {AnyAction} from 'redux'

export const paidPlansEnabled = (state = false, action: AnyAction): boolean => {
  switch (action.type) {
    default:
      return state
  }
}
